import { useTranslation } from 'react-i18next';

import { getContrastColor } from '@/pages/Chat/utils';
import { EditOutlined } from '@ant-design/icons';

import styles from '../Messages.module.scss';

const MiniGroupElement = ({ groupName, groupColor, countUsers, onSelect }) => {
  const { t } = useTranslation('chat');
  const textColor = getContrastColor(groupColor);

  return (
    <div className={styles['mini-group-element']} style={{ backgroundColor: groupColor, color: textColor }}>
      <div className={styles['mini-group-element__info']}>
        <p className={styles['mini-group-element__name']}>{groupName}</p>
        <p className={styles['mini-group-element__user-count']}>
          {countUsers} {t('member')}
        </p>
      </div>
      <EditOutlined onClick={onSelect} className={styles['mini-group-element__icon']} />
    </div>
  );
};

export default MiniGroupElement;
